<template>
  <el-container class="height100">
    <el-aside width="200px" class="dept-aside">
      <department_tree @node-click="onNodeClick" :key="timer"/>
    </el-aside>
    <el-container class="height100 Dept"  ref="departmentCon">
      <el-main v-show="showmode=='LIST'" class="el-mainContent height100 flexColumn">
        <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight">
          <el-col :span="12" class="normalLineH">{{$t('dept_list')}}</el-col>
          <el-col :span="12" class="align-right normalLineH">
            <el-button type="primary" @click="onCreateBtnClick" size="small">{{$t('new')}}</el-button>
            <el-button type="primary" @click="onImportBtnClick" size="small" plain  v-if='!flag'>{{$t('department_import')}}</el-button>
            <el-button @click="onDeleteBtnClick" size="small" type="danger" plain>{{$t('del')}}</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form :inline="true" :model="searchdata" class="form-inline" size="mini" @submit.native.prevent>
              <el-form-item >
                <el-input v-model="searchdata.data.name" placeholder="部门名称" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
                <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 部门列表 -->
        <el-table :data="tableData.datas" 
        stripe
        @row-click="onRowClick" 
        ref="departmentList"
        :row-key="handleReserve" 
        @selection-change="handleSelectionChange"
        header-cell-class-name="tableHeaderbg"
        class="Trpointer"
        size="small"
        :height="tableListConHeight">
          <el-table-column type="selection" width="55" ></el-table-column>
          <el-table-column prop="name" :label="$t('dept_name')"></el-table-column>
          <el-table-column prop="superior.name" :label="$t('superior_dept')"></el-table-column>
          <el-table-column prop="level" :label="$t('level')"></el-table-column>
          <el-table-column v-for="(elm,index) in fieldextendsList" :key="index" :prop="elm.name" :label="elm.label"></el-table-column>
          
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="searchTableData"
          :current-page.sync="searchdata.currpage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchdata.pagelines"
          :page-count="4"
          layout="prev, pager, next, total, sizes"
          background
          :total="tableData.rowCount?tableData.rowCount:0"
        ></el-pagination>
      </el-main>
      <el-main v-show="showmode=='DETAIL'" class="el-mainContent height100">
        <!-- 部门详情 -->
        <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight" ref="departmentDetailBtn">
          <el-col :span="12" class="normalLineH">{{$t('dept_info')}}</el-col>
          <el-col :span="12" class="align-right normalLineH">
            <el-button @click="showList" size="small" type="primary" plain>{{$t('back')}}</el-button>
            <el-button type="primary" @click="onSaveBtnClick" size="small">{{$t('save')}}</el-button>
          </el-col>
        </el-row>
        <el-form 
        ref="departmentDetailForm" 
        :model="content" 
        label-position="top" 
        label-width="180px" 
        size="mini" 
        class="form-inline formMain" 
        :rules="rules"
        >
            <el-row>
              <el-col :span="6">
                <el-form-item :label="$t('dept_name')"  class="padding0Label" prop="name">
                  <el-input type="text" v-model="content.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6"  :offset="6">
                <el-form-item :label="$t('orderByNo')"  class="padding0Label">
                  <el-input type="number" v-model="content.orderByNo" @blur="onOrderByNoBlur"></el-input>
                </el-form-item>
              </el-col>
              
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="$t('superior_dept')"  class="padding0Label" prop="superior">
                  <el-input
                    type="text"
                    :disabled="true"
                    :value="content.superior?content.superior.name:''"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item >
                  <el-button @click="onSelectDept" class="marginTop29">
                    {{$t('select_dept')}}
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="4">
                <el-form-item :label="$t('code')"  class="padding0Label">
                  <el-input type="text" v-model="content.code"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="$t('valid')"  class="padding0Label padding0Switch">
                  <el-switch
                    v-model="content.valid"
                    :active-value="1"
                    :inactive-value="0"
                  ></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="6"></el-col>
            </el-row>
            <div class="extendFlex">
              <div class="extend" v-for="(elm,index) in fieldextends" :key="index">
                <div v-if="elm.type=='string'"  class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-input type="text" v-model="content[elm.name]" :disabled="elm.isReadonly" style="width:50%"></el-input>
                </div>
                <div v-if="elm.type=='date'"  class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  {{content[elm.name]}}
                  <el-date-picker
                    v-model="content[elm.name]"
                    type="date"
                    :disabled="elm.isReadonly"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
                <div v-if="elm.type=='upload'" class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <div v-if="content[elm.name]">
                    <div class="pic-list"
                      :key="index"
                      @mouseover="changeActive(index)" 
                      @mouseout="removeActive"
                    >
                      <div class="slider-list">
                        <img :src="content[elm.name]" v-if="(content[elm.name].indexOf('http://')>=0||content[elm.name].indexOf('https://')>=0)" />
                        <img :src="contextPath + content[elm.name]" v-else/>
                      </div>
                      <transition name="fade">
                        <div class="mask" v-if="isShow && index == activeIndex">
                          <span @click="handlePictureCardPreview(content[elm.name])">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span @click="opendialog(elm.name)">
                            <i class="el-icon-delete"></i>
                          </span>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <el-upload
                    :action="getFileUrl()"
                    list-type="picture-card"
                    :disabled="elm.isReadonly"
                    :class="elm.isReadonly==true?'allowed':''"
                    accept="image/*"
                    name="file"
                    :data="fileData"
                    :on-success="function (file) {return fileSuccess(file,elm.name)}"
                    :show-file-list="false"
                    >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="contextPath + dialogImageUrl" alt="">
                  </el-dialog>
                </div>
                <div v-if="elm.type=='clob'">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-input
                    type="textarea"
                    :rows="3"
                    style="width:50%"
                    :disabled="elm.isReadonly"
                    :placeholder="$t('placeholder_enter_content')"
                    v-model="content[elm.name]">
                  </el-input>
                </div>
                <div v-if="elm.type=='radio'">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-radio-group v-model="content[elm.name]" :disabled="elm.isReadonly">
                    <el-radio 
                      v-for="(options,index) in elm.options"
                      :key="index"
                      :label="options.label"
                      >{{options.label}}
                    </el-radio>
                  </el-radio-group>
                </div>
                <div v-if="elm.type=='checkbox' && elm.options.length > 0">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-checkbox-group v-model="elm.checkboxList" @change="hanleChange($event,elm.name)" :disabled="elm.isReadonly">
                    <el-checkbox 
                      v-for="item in elm.options"
                      :key="item"
                      :label="item">
                      {{item}}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div v-if="elm.type=='select'"  class="padding0Label">
                  <div class="text">
                    <span style="color:red" v-if="elm.isNotNull">*</span>
                    {{elm.label}}
                  </div>
                  <el-select  v-model="content[elm.name]" :placeholder="$t('placeholder_select')" :disabled="elm.isReadonly">
                    <el-option
                      v-for="(item,index) in elm.options"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- 用户列表 -->
            <p class="smallHeader">{{$t('owned_user')}}</p>
            <el-table :data="content.subUser?content.subUser.datas:emptyAray" 
            stripe
            ref="departmentDetailUser"
            :row-key="handleReserve" 
            @selection-change="handleSelectionChange"
            header-cell-class-name="tableHeaderbg">
              <el-table-column type="selection" width="55" ></el-table-column>
              <el-table-column prop="name" :label="$t('name')"></el-table-column>
              <el-table-column prop="loginno" :label="$t('loginno')"></el-table-column>
              <el-table-column prop="email" :label="$t('email')"></el-table-column>
              <el-table-column prop="telephone" :label="$t('tel')"></el-table-column>
              
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange2"
              @current-change="searchTableData2"
              :current-page.sync="searchdata2.currpage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="searchdata2.pagelines"
              :page-count="4"
              layout="prev, pager, next, total, sizes"
              background
              :total="content.subUser?content.subUser.rowCount:0"
            ></el-pagination>
          </el-form>
      </el-main>
      
    </el-container>

    <department_select :visible.sync="deptSelectVisible" @select-ok="onSelectDeptOk" v-if="deptSelectVisible" />
    <fileUpload :visible.sync="fileUploadVisible" v-if="fileUploadVisible" :nowOption="nowOption" @success="searchTableData"/>
  </el-container>
</template>

<script>
import department_tree from "@/components/department_tree.vue";
import department_select from "@/components/department_select.vue";
import fileUpload from "@/components/fileUpload.vue";
import contextPath from "@/contextPath.js"
export default {
  components: {
    department_tree,
    department_select,
    fileUpload
  },
  created() {
    this.searchTableData();
    this.$api.getRootDepartment(this.$route.query.domainid, {
      onSucess: resp => {
        let rootDepartment = resp.data.data;
        if(rootDepartment){
          this.defaultSuperior=rootDepartment
        }else{
          this.defaultSuperior=null;          
        }
        
      }
    });
    let dataJson={ 
      currpage:1,
      pagelines:30,
      data:{
        type:"",
        fortable:"tableDept",
        domainid: this.$route.query.domainid,
        belong:"All"
      }
    }
    this.$api.getFieldExtends(
      dataJson,
      {
        onSucess: resp => {
          this.fieldextends=resp.data.data.datas
          this.fieldextends.forEach(elm=>{
            if(elm.type == "radio" || elm.type == "select" || elm.type == "checkbox"){
              let option = elm.options.split(";");
              let arr = [];
              if(elm.type == "radio" || elm.type == "select"){
                for(let i=0;i<option.length;i++){
                  let obj = {}
                  obj.label = option[i];
                  obj.value = option[i];
                  arr.push(obj);
                }
                elm.options = arr;
              }else if(elm.type == "checkbox"){
                elm.checkboxList = this.content[elm.name].split(";");
                elm.options = option;
              }
            }
            if(elm.enabel){
              this.fieldextendsList.push(elm);
            }
          })
        }
      }
    );
  },
  mounted(){
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight=this.$refs.departmentList.$el.getClientRects()[0].height-41;
    // this.$refs.departmentDetail.$el.getClientRects()[0].height=this.$refs.departmentCon.$el.getClientRects()[0].height-this.$refs.departmentDetailBtn.$el.getClientRects()[0].height;

  },
  data() {
    return {
       flag:localStorage.getItem("isDeparmentAdminRole")=="false"?false:true,
      contextPath:contextPath,
      deptSelectVisible: false,
      searchdata: {
        domainid: this.$route.query.domainid,
        superiorid: "",
        currpage: 1,
        pagelines: 10,
        orderby: "",
        data:{
          name: "",
        }
      },
      searchdata2: {
        currpage: 1,
        pagelines: 10,
      },
      content: {}, //部门信息对象
      tableData: {},
      showmode: "LIST", //LIST 或 DETAIL，默认为LIST
      multipleTable:[], //部门列表的复选框所需
      multipleSelection:[],//选中部门的id
      defaultSuperior:"",//默认的上级部门
      emptyAray:[],
      timer:'',
      fieldextends:[],
      fieldextendsList:[],
      options:[],
      radioValue:'',
      checkboxList:[],
      selectValue:'',
      empty:"",
      rules:{
        name:[
          {required: true, message: '部门名称不能为空', trigger: 'blur'},
        ],
        // superior:[
        //   {required: true, message: '上级部门不能为空', trigger: 'blur'},
        // ],
      },
      tableListConHeight:null,
      fileUploadVisible:false,
      nowOption:"depImport",
      uploadUrl:"/authtime/uploads",
      filePath: "/uploads/lib/img",
      fileData:{
        path:'/uploads/lib/img',
        filePath:'/uploads/lib/img',
      },
      isShow:false,
      activeIndex:-1,
      imgBase:'',
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  methods: {
    resetSearchTableData(){
      this.searchdata.data.name='';
      this.searchTableData();
    },
    handleReserve(row){
      return row.id
    },
    /**
     * 复选框选中
     */
    hanleChange(val,fieldName){
      let checkboxValue = ""
      for(let i=0;i<val.length;i++){
        if(checkboxValue){
          checkboxValue = checkboxValue + ";" + val[i];
        }else{
          checkboxValue = val[i];
        }
      }
      this.content[fieldName] = checkboxValue;
    },
    fileSuccess(response, name){
      let that = this;
      let file = response.data[0];
      that.content[name] = file.filePath;
    },
    getFileUrl(){
      return this.$api.getLogoUrl(this.uploadUrl+"?path="+this.filePath+"&icon=true")
    },
    changeActive(index) {
      this.activeIndex = index;
			this.isShow = true;
		},
    removeActive() {
			this.isShow = false;
		},
    /**
     * 点击预览
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    opendialog(name){
      this.content[name] = '';
    },
    onOrderByNoBlur(){
      this.content.orderByNo=parseInt(this.content.orderByNo);
    },
    onNodeClick(dept) {
      
      this.searchdata.superiorid = dept.id;
      this.defaultSubSuperior=dept
      this.searchTableData();
      this.showList();
    },

    onSelectDept() {
      this.deptSelectVisible = true;
    },

    onSelectDeptOk(dept) {
      if(this.content.id == dept.id){
        this.$message({
          showClose: true,
          message: "上级部门不能选择自己",
          type: "error"
        });
        return false;
      }
      this.content.superior = dept;
    },

    showDetail(dept) {
      console.log(dept)
      this.content = dept;
      this.showmode = "DETAIL";
    },

    showList() {
      this.searchTableData();
      this.showmode = "LIST";
    },

    //新建
    onCreateBtnClick() {
      // this.showDetail({superior:this.defaultSuperior,valid:1});
      //  this.showDetail({superior:null,valid:1});
       this.showDetail({superior:this.defaultSubSuperior?this.defaultSubSuperior:this.defaultSuperior,valid:1,name: ''});
    },
    //部门导入
    onImportBtnClick(){
      this.fileUploadVisible=true;
    },

    //保存
    onSaveBtnClick() {
       console.log(this.content.superior)
      if(parseInt(this.content.orderByNo)<0){
        this.$message({
          showClose: true,
          message: "排序号不能为负数",
          type: "error"
        });
        return false;
      }
     
      // if(this.content.superior==null||this.content.superior.name===""){
      //   this.$message({
      //     showClose: true,
      //     message: "请选择上级部门",
      //     type: "error"
      //   });
      //   return false;
      // }
      // 判断当前项是否为必填项
      let checkArr = []
      let checkTip = ""
      let have = true
      if(this.fieldextends.length > 0){
        this.fieldextends.map(item => {
          if(item.isNotNull){
            checkArr.push(item)
          }
        })
        if(checkArr.length > 0){
          checkArr.some(ele => { if(!this.content[ele.name]){
            have = false
            checkTip += ele.label + ','
          } })
        }
        if(!have){
          this.$message.error(checkTip.substring(0, checkTip.lastIndexOf(',')) + '字段为必填项')
          return false;
        }
      }
      let content = JSON.parse(JSON.stringify(this.content));
      if (content && content.id) {
        //更新
        if(content.superior){
          content.superiorid=content.superior.id
        }
        this.$api.updateDepartment(
          {
            domainid: this.$route.query.domainid,
            departmentid: content.id,
            data: content
          },
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('msg_save_success'),
                  type: "success"
                });
                this.timer=new Date().getTime();
                this.showList();
                this.searchTableData();

              } else {
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
            }
          }
        );
      } else {
        //新建
        if(content.superior){
          content.superiorid=content.superior.id
        }
        this.$api.createDepartment(
          { domainid: this.$route.query.domainid, data: content },
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('msg_save_success'),
                  type: "success"
                });
                this.timer=new Date().getTime();
                this.searchdata.data.name="";
                this.showList();
                this.searchTableData();
              } else {
                // resp.data.errmsg
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
            }
          }
        );
      }
    },

    //删除
    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){
        this.$api.deleteDepartment({
          data:this.multipleSelection
        },{
          onSucess:resp =>{
            if(resp.data.errcode==0){
              this.$message({
                  showClose: true,
                  message: this.$t('msg_del_success'),
                  type: "success"
                });
              this.timer=new Date().getTime();
              this.searchTableData();
              

            }else{
              this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
            }
          },
          onError:function(){

          }
        })
      }else{
        this.$message({
          showClose: true,
          message: "请选择一个部门",
          type: "error"
        });
      }
    },
    handleSelectionChange(val) {
      var arr = [];
       val.forEach((val) => {
        this.tableData.datas.forEach((v) => {
          if(val.id == v.id){
            arr.push(val.id)
          }
        })
      })   
      this.multipleSelection = arr;
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    handleSizeChange2(size){
      this.searchdata2.pagelines=size;
      this.searchTableData2();
    },
    searchTableData() {
      let params = {
        ...this.searchdata,
        data:{
          name: this.searchdata.data.name.replace(/\%/g, '%25')
        }
      }
      this.$api.getSubDepartments(params, {
        onSucess: resp => {
          this.tableData = resp.data.data;
        }
      });
    },
    searchTableData2() {
      this.$api.getDepartmentUsers(this.content.id,this.searchdata2, {
        onSucess: resp => {
          this.content.subUser = resp.data.data;
          this.$forceUpdate();
        }
      });
    },

    onRowClick(row) {
      if(row.editFlag!=="true"){
        this.$message({type:'warning',message:"您无此部门的管理权限，无法进行操作"})
        return false
      }
      this.$api.getDepartmentUsers(row.id,this.searchdata2, {
        onSucess: resp => {
          row.subUser=resp.data.data
          this.showDetail(row);
          this.$refs['departmentDetailForm'].resetFields();
        }
      });
      
    },
  }
};
</script>

<style lang="scss" scoped>

</style>